          var $r = jQuery.noConflict();
          $r('.popBox').hide();
          $r(document).ready(function() {

            

            $r(".prodPic").click(function(){
              //$r(this).toggleClass("active");

              var a  = $r(this).parent().find('.rdesc').html();
              //alert(a);
              $r('.popBox>.content').html(a);
              $r('.popBox').show();

            });
            $r(".popX").click(function(){
              $r('.popBox').hide();
            });


            $r('[data-quantity-plus]').click(function() {
              var inputField = $r(this).siblings('.quantity__input');
              var currentValue = parseInt(inputField.val());

              if (currentValue < 10) {
                var sum = calculateSum();
                if (sum + 1 <= 10) {
                  inputField.val(currentValue + 1);
                } else {
                  updateInfo("You have filled your box!<br> For any changes or to delete, click 'Clear Box'. Once complete, please click 'Build Box' to add to Cart.");

                }
              } else {
                updateInfo("You have filled your box!<br> For any changes or to delete, click 'Clear Box'. Once complete, please click 'Build Box' to add to Cart.");
              }
              boxTotal();
            });

            $r('[data-quantity-minus]').click(function() {
              var inputField = $r(this).siblings('.quantity__input');
              var currentValue = parseInt(inputField.val());

              if (currentValue >= 1) {
                inputField.val(currentValue - 1);
              }
              boxTotal();
            });

            function calculateSum() {
              var sum = 0;
              $r('.quantity__input').each(function() {
                sum += parseInt($r(this).val());
              });
              return sum;
            }

            function boxTotal() {
              var sum = 0;
              var total = 0 ;
              var totalCurr = 0 ;
              $r('.quantity__input').each(function() {
                sum += parseInt($r(this).val());
                var q = parseInt($r(this).val());
                total += $r(this).data('price') * q;
                totalCur = (total/100).toFixed(2);
              });
              //ramnati console.log("Total"+totalCur);
              $r('#iTot').val(totalCur);
              $r('#iQty').val(sum);
              return totalCur;
            }

            $r('.build-box').click(function() {
              var quantities = {};
              $r('.quantity__input').each(function() {
                var variantId = $r(this).data('vid');
                var quantity = parseInt($r(this).val());
                quantities[variantId] = quantity;
              });

              keyValue(quantities)
              updateCart(quantities,"update");
            });

            $r('.clear-box').click(function() {
              var quantities = {};
              $r('.quantity__input').each(function() {
                var variantId = $r(this).data('vid');
                var quantity = 0;
                $r(this).val(quantity);
                quantities[variantId] = quantity;
              });

              keyValue(quantities)
              updateCart(quantities,"clear");
              boxTotal();
            });




            // debug values helper
            const keyValue = (input) => Object.entries(input).forEach(([key,value]) => {
              ////ramnati console.log(key,value)
            })

            function updateInfo(msg){
              $r('#info').html(msg);
              //alert(msg);
            }

            function updateCart(quantities,boxAction) {
              var attributes = {};
              attributes["BoxTotal"]= "0";
              if (boxAction == "clear"){
                attributes["BoxTotal"]= "0";
                updateInfo("Box is cleared");
                jQuery.post(window.Shopify.routes.root + 'cart/update.js',{updates:quantities, attributes:attributes})
                  .success(function( data ) {
                    updateInfo("Your custom Box is cleared");
                  });
              }
              if (boxAction == "update"){
                var sum = calculateSum();
                if (sum < 10) {
                  updateInfo("Your box isn’t full! Please add 10 items to complete your box.");
                } else {
                  attributes["BoxTotal"]= boxTotal().toString();
                  var rst = jQuery.post(window.Shopify.routes.root + 'cart/update.js', { updates: quantities, attributes: attributes })
                  .always(function(data, textStatus, jqXHR) {
                    window.location.href = "/cart";
                    if (textStatus === 'success') {
                      try {
                        var parsedData = JSON.parse(data);
                        // Process the parsed data
                        //ramnati console.log(parsedData);
                      } catch (error) {
                        //ramnati console.log("Error parsing JSON:", error);

                      }
                    } else {
                      //ramnati console.log("AJAX request failed:", textStatus);
                    }
                  });







                }
              }



            }

          });